module.exports = __webpack_public_path__ + "img/box-dollar.2df71295.svg";